var React = require('react');

function StationeryCreaseStroke (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"fill":"#FFFFFF","d":"M40.862,40.769H0V0L40.862,40.769z M6,34.769h20.353L6,14.463V34.769z"})));
}

StationeryCreaseStroke.defaultProps = {"version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"40.862px","height":"40.769px","viewBox":"0 0 40.862 40.769","enableBackground":"new 0 0 40.862 40.769","xmlSpace":"preserve"};

module.exports = StationeryCreaseStroke;

StationeryCreaseStroke.default = StationeryCreaseStroke;
